import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "styles/main.scss";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "app/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
// NOTE: StrictMode is moved down the tree
// REASON: This causes an issue with krpano when loaded inside `useEmbedPano`
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
